/*****************************************************************
 Json送信用クラス定義
 *****************************************************************/

// import { stringifyQuery } from "vue-router";

/*****************************************************************
 Jsonコンテナ共通ヘッダー
 *****************************************************************/
export class CommonHeader
{
    uid = 0;            // ユーザーID
    pwd = "";           // パスワード
    langCd = "";        // 言語コード
    cntryCd = "";       // 国コード
    ttype = "";         // 端末タイプ
    sysCd = "";         // システムコード
    tmpltCd = "";      // テンプレートコード
    actionFlag = "";    // アクションフラグ
    sttsCd = "";        // ステータスコード（サーバーでセット)
    msg = "";           // メッセージ（サーバーでセット)

    constructor(uid: number, pwd: string, langCd: string, cntryCd: string, ttype: string,
        sysCd: string, tmpltCd: string)
    {
        this.uid = uid;
        this.pwd = pwd;
        this.langCd = langCd;
        this.cntryCd = cntryCd;
        this.ttype = ttype;
        this.sysCd = sysCd;
        this.tmpltCd = tmpltCd;
    }
    setActionFlag(val :string) {this.actionFlag=val;}
}
export let commonHeader: CommonHeader; // Json用共通ヘッダー
export function setCommonHeader(val: CommonHeader) {commonHeader=val;}


/**
 * 受取った送信用データーに共通ヘッダーを付与したJsonを返す
 */
export function toJson(data: any)
{
    return (JSON.stringify(commonHeader)+JSON.stringify(data)).replace('}{',',');
}

/*****************************************************************
 Jsonコンテナ定義
 *****************************************************************/
/**
 * B000010JCコンテナ
 * バーコード/QRコード取得用
 */
export class B000010JC
{
    brCdFmt = ""; // バーコードフォーマット
    dspCd = "";   // 表示コード

    // constructor(){}
}

/**
 * B040030JCコンテナ
 * 血圧グラフ取得用
 */
export class B040030JC
{
	drawAve = false;	    // 平均血圧
	drawMorning = false;	// 朝血圧
	drawNight = false;	    // 夜血圧
    weeks: any = null;          // 対象期間(週数)
    wd: any = null;			    // グラフの横幅(pix)
}

/**
  * C000010JCコンテナ
  * プロジェクト登録/更新/削除/取得用
  */
export class C000010JC
 {
     mpt007: any = null;
 }

/**
 * C000011JCコンテナ
 * プロジェクト（グループ）一覧取得用
 */
export class C000011JC
{
    // 検索条件
    inMpt007: any = null;
    // 検索結果
    outMpt007s: any = [];
}

/**
 * C000012JCコンテナ
 * プロジェクト登録/更新/削除/取得用
 */
export class C000012JC
{
    mpt007: any = null;				// プロジェクト情報
    prjLogoFilePath: any = null;	// サーバー上にアップロードしたロゴファイルの絶対パス
    deletePrjLogo = false;		// ロゴ削除用 true - 削除する、 false - 削除しない
    prjPhtFilePath: any = null;		// サーバー上にアップロードした画像ファイルの絶対パス
    deletePrjPht = false;		//画像ゴ削除用 true - 削除する、 false - 削除しない
}

/**
 * C000020JCコンテナ
 * プロジェクトに参加してないユーザー取得用
 */
export class C000020JC
{
    // 検索条件
    prjNo: any = null;      // プロジェクトNo.
    eml: any = null;	    // Eメール
    nckNm: any = null;	    // ニックネーム
    maxResults = 0;	// 最大取得件数
    // 検索結果
    outRsc001s: any = [];
}

/**
 * C000030JCコンテナ
 * プロジェクトへの既存メンバー一括登録用
 */
export class C000030JC
{
    // 入力情報
    // sysCd: any = null;               // システムコード
    // tmpltCd: any = null;             // テンプレートコード
    inMpt014s: any[] = [];    // メンバー情報
    invMail: any = false;             // 招待メール送信有無
    mailTmpl: any = null;            // 既存ユーザー用招待メールテンプレートコード
    addInMpt014(obj: any)
    {
        this.inMpt014s.push(obj);
    }
}

/**
 * C000040JCコンテナ
 * メンバー登録/更新/削除/取得用
 */
export class C000040JC
{
    // 検索条件
    // sysCd: any = null;      // システムコード
    // tmpltCd: any = null;    // テンプレートコード
    inMpt014: any = null;
    rllCds: any[] = [];  // 取得対象の役割コード
    invMail: any = false;    // 招待メール送信有無
    mailTmpl1: any = null;  // 既存ユーザー用招待メールテンプレートコード
    mailTmpl2: any = null;  // 新規ユーザー用招待メールテンプレートコード
    mailTmpl3: any = null;  // グループ除外通知用メールテンプレートコード
    // 検索結果
    outMpt014s = [];
    addRllCds(obj: any)
    {
        this.rllCds.push(obj);
    }
}
// export let c000040Keep = "";       // メンバー一覧
// export let c000040KeepIdx = -1;    // メンバー選択済みインデックス

/**
 * C000070JCコンテナ
 * プロフィール取得/更新用
 */
export class C000070JC
{
	// 取得用
    mpt001: any = null;		    // ユーザー基本情報
    photoLoaded = false;	// 画像有無(画像がユーザー補足情報１に存在する場合はtrue）
    // 更新用
    filePath: any = null;	        // アップロードしたイメージの絶対パス
    // 画像削除用
    deletePhoto = false;   // trueの場合はユーザー補足情報１から画像を削除
}
// export let c000070Keep = "";          // ユーザー基本情報

/**
 * C000080JCコンテナ
 * 仮パスワード発行用
 */
export class C000080JC
{
    email = "";	// パスワード発行対象のメールアドレス
    setEmail(val: string) {this.email=val;}
}

/**
 * C000090JCコンテナ
 * ユーザー保有端末情報登録用
 */
export class C000090JC
{
    mpt040: any = null;	// ユーザー保有端末ID
}

/**
 * C000100JCコンテナ
 * ユーザーの有料オプション確認状況取得用
 */
export class C000100JC
{
    // 取得条件
	// sysCd: any = null;		// システムコード
	// tmpltCd: any = null;		// テンプレートコード
	strOptCd: any = null;	// ストアーオプションコード
	optSttsCd: any = null;	// オプションステータスコード
	// 結果
	qualified = false; // 有料オプション確認状況
}

/**
 * C000110JCコンテナ
 * 招待メール送信用
 */
export class C000110JC
{
    // sysCd: any = null;      // システムコード
    // tmpltCd: any = null;    // テンプレートコード
    prjNo: any = null;      // プロジェクトNo.
    toUid: any = null;      // 招待メールの送信先ユーザーID
    mailTmpl: any = null;   // メールテンプレートコード(例：04001_1)
}

/**
 * C000120JCコンテナ
 * グループ参加状況一覧用
 */
export class C000120JC
{
    memUid: any = null;             // 検索及び更新対象メンバーのユーザーID
    // sysCd: any = null;              // 検索用システムコード
    // tmpltCd: any = null;            // 検索用テンプレートコード
    rllCds: any = [];      // 検索用役割コードの配列
    mpv003s: any = [];     // Mpv003のリスト：検索結果格納及び、更新用
    addRllCds(obj: any)
    {
        this.rllCds.push(obj);
    }
    addMpv003(obj: any)
    {
        this.mpv003s.push(obj);
    }
}
// export let c000120Keep: any;       // プロジェクト一覧
// export function setC000120Keep(val: any) {c000120Keep = val;}

// export let c000120KeepIdx = -1;    // プロジェクト選択済みインデックス
// export function setC000120KeepIdx(val: number) {c000120KeepIdx = val;}


/**
 * C000140JCコンテナ
 * ユーザー設定情報用
 */
export class C000140JC
{
	// 検索用キー
	// sysCd: any = null;			    // システムコード
	// tmpltCd: any = null;		    // テンプレートコード
	// 更新用
	inMpt041s: any = [];	// 更新用ユーザー設定情報のリスト
	// 検索結果格納用
	outMpt041s: any = null;		    // 検索結果格納用ユーザー設定情報のリスト
    addinMpt041s(obj: any)
    {
        this.inMpt041s.push(obj);
    }
}

/**
 * C000150JCコンテナ
 * お知らせ用
 */
export class C000150JC
{
	// 検索用キー
	// sysCd: any = null;			    // システムコード
	// tmpltCd: any = null;		    // テンプレートコード
	// 検索結果格納用
	outMpt059s: any = null;		    // 検索結果格納用
}

/**
 * C000160JCコンテナ
 * プロジェクトの有料オプション確認状況取得用
 */
export class C000160JC
{
    // 取得条件
	// sysCd: any = null;		// システムコード
	// tmpltCd: any = null;		// テンプレートコード
	strOptCd: any = null;	// ストアーオプションコード
	optSttsCd: any = null;	// オプションステータスコード
	prjNo: any = null;	// プロジェクトNo.
    // 結果
	qualified = false; // 有料オプション確認状況
}
/**
 *  C000170JCコンテナ
 * セッションID取得用
 */
export class C000170JC
{
    // 取得結果
    sid: any = null;
}

/**
 *  C000180JCコンテナ
 * 問合せメール送信用
 */
export class C000180JC
{
    sendTo: any = null;		// メール送信先
    emlTmpltCd: any = null;	// メールテンプレートコード
	msgBody: any = null;	// メッセージ本文
	sndrAddr: any = null;	// 送信者アドレス
	sndrNm: any = null;		// 送信者名
}

/**
 *  C000190JCコンテナ
 * ログオン用
 */
export class C000190JC
{
    eml: any = null;                // Eメール
    pwd: any = null;                // パスワード
    langCd: any = null;               // 言語コード
    mpt003 = new Mpt003();		// 接続情報
}

/**
 *  C000200JCコンテナ
 * メンバーのプロジェクト内役割保有確認用
 */
export class C000200JC
{
    // 検索条件
    memUid: any = null;             // 対象メンバーのユーザーID
    sysCd: any = null;              // システムコード
    tmpltCd: any = null;            // テンプレートコード
    prjNo: any = null;              // プロジェクトNo.
    rllCds: any = [];      // 役割コードの配列
    // 検索結果
    exists: any = null;
    addRllCd(obj: any)
    {
        this.rllCds.push(obj);
    }
}

/**
 * C000210JCコンテナ
 * 権限情報取得用
 */
export class C000210JC
{
    // 検索条件
    sysCd: any = null;              // システムコード
    tmpltCd: any = null;            // テンプレートコード
    pageId: any = null;             // 画面ID
    fnctCd: any = null;             // 機能コード
    rllCd: any = null;              // 役割コード
}

/**
  *  C000500JCコンテナ
  *  アクション登録/更新/削除用
  */
export class C000500JC
{
    prjNo: any = null;          // プロジェクトNo.
    mpt016: any = null;         // アクション情報
}

/**
 *  C010010JCコンテナ
 * プロジェクトカレンダーとユーザーのイベント出欠返信状況取得用
 */
export class C010010JC
{
	// 取得条件
	prjNo: any = null;		// プロジェクトNo.
	cntryCd: any = null;	// 国コード
	fromYyyymm: any = null;	// 取得開始年月日
	toYyyymm: any = null;	// 取得終了年月日
	yyyy: any = null;		// 取得年
	fromWeek: any = null;	// 取得開始週番号
	toWeek: any = null;		// 取得終了週番号
	ymd: any = null;		// 取得年月日
	rllCds: any = [];      // 取得用役割コードの配列
    addRllCds(obj: any)
    {
        this.rllCds.push(obj);
    }
}

/**
 * C010011JCコンテナ
 *  指定したイベントNoを含む1ヵ月分のカレンダー取得用コンテナ
 */
export class C010011JC
{
    evntNo: any = null;     // イベントNo.
}

/**
  *  C010020JCコンテナ
  *  出欠一覧取得用
  */
export class C010020JC
{
    prjNo: any = null;          // プロジェクトNo.
    evntNo: any = null;         // イベントNo.
    // 取得結果
    mpv005s: any = null;        // 出欠一覧
}

/**
  *  C010030JCコンテナ
  *  イベント通知メール送信用
  */
export class C010030JC
{
    // sysCd: any = null;          // システムコード
    // tmpltCd: any = null;        // テンプレートコード
    prjNo: any = null;          // プロジェクトNo.
    evntNo: any = null;         // イベントNo.
    sendMsg: any = null;        // 送信メッセージ
    emlTmpltCd: any = null;     // Eメールテンプレートコード
    sendAttndncKbns: any = []; // 送信対象出欠区分
}

/**
  *  C010040JCコンテナ
  *  イベント登録/更新/削除/取得用
  */
export class C010040JC
{
    // sysCd: any = null;      // システムコード
    // tmpltCd: any = null;    // テンプレートコード
    mpt025: any = null;     // イベント情報
    // 繰り返しイベントの変更範囲指定
    // true - 全繰り返しイベントを変更、 false - このイベントのみ変更
    modifyAll = false;
    // true - メール送信有り、 false - メール送信無し
    sendMail = false;
    // メールテンプレートコード
    emlTmpltCd: any = null;
    // 役割コード
    rllCds: any = [];
    addRllCd(obj: any)
    {
        this.rllCds.push(obj);
    }
}

/**
  *  C010051JCコンテナ
  *  メモ登録/更新/削除用
  */
export class C010051JC
{
    // 登録/更新/削除内容
    sysCd: any = null;                          // システムコード
    tmpltCd: any = null;                       // テンプレートコード
    memoNo: any = null;                     // メモ番号
    ymd: any = null;					        // 年月日
    strtHhmm: any = null;				    // 開始時刻
    endHhmm: any = null;				    // 終了時刻
    titl: any = null;					            // タイトル
    memo: any = null;					    // メモ
    selectedItems: any = []; // カレンダーアイテムリスト
    attachedPhoto: any = null;			// 画像
    deleteMemoObjNos: any = [];		// 削除対象メモオブジェクト番号
    mpt202: any = null;					    // メモ_リマインダー情報
    // 取得結果
	calendarDay: any = null;		        // デイリーカレンダー
	memoRecordStatus: any = null;	    // メモ記録状況
    addSelectedItem(obj: any)
    {
        this.selectedItems.push(obj);
    }
    addDeleteMemoObjNo(obj: any)
    {
        this.deleteMemoObjNos.push(obj);
    }
}

/**
  *  C010060JCコンテナ
  *  パーソナルMonthlyカレンダーを取得用
  */
export class C010060JC
{
    fym: any = null;            // 取得開始年月
    tym: any = null;            // 取得終了年月
    items: any = [];   // メモカテゴリーコードのリスト
    addItem(obj: any)
    {
        this.items.push(obj);
    }
}

/**
  *  C010070JCコンテナ
  *  パーソナルDailyカレンダーを取得用
  */
export class C010070JC
{
    yyyymmdd: any = null;       // 取得年月日
    items: any = [];   // メモカテゴリーコードのリスト
    addItem(obj: any)
    {
        this.items.push(obj);
    }
}

/**
  *  C010080JCコンテナ
  *  メモ検索用
  */
export class C010080JC
{
	// 取得条件
	fromYyyymmdd: any = null;	// 取得開始年月日
	toYyyymmdd: any = null;		// 取得終了年月日
	daysPast: any = null;		// 過去日数
	andKeywdTitle: any = null;	// タイトル検索キーワード(AND)
	orKeywdTitle: any = null;	// タイトル検索キーワード(OR)
	exKeywdTitle: any = null;	// タイトル検索キーワード(除外)
	andKeywdBody: any = null;	// 本文検索キーワード(AND)
	orKeywdBody: any = null;	// 本文検索キーワード(OR)
	exKeywdBody: any = null;	// 本文検索キーワード(除外)
	ymdDspMode: any = null;		// 年月日検索モード D:年月日、P：過去日数
	// 取得結果
	memos: any = null;		    // メモ
}

/**
 * C040010JCコンテナ
 * メンバー体調一覧取得用
 */
export class C040010JC
{
    // 取得条件
    fromYmd: any = null;	    // 開始年月日
    toYmd: any = null;		    // 終了年月日
    prjNo: any = null;         // プロジェクトNo.
    uids: any = [];	// 対象ユーザーIDのリスト
    tmptGt: any = null;		// 体温(以上)
    tmptUnt = "14";	    // 体温単位コード(14=摂氏)
    bprsUGt: any = null;	    // 血圧上（以上）
    bprsLLt: any = null;	    // 血圧下（以下）
    physcCndCd: any = null;	// 体調コード
    wghtGt: any = null;		// 体重（以下）
    wghtUnt = "12";	    // 体重単位コード(12=kg)
    // 取得結果
    mpv002s: any;
}

/**
 * C040011JCコンテナ
 * メンバー体調一覧取得用2
 */
export class C040011JC
{
    // 取得条件
    fromYmd: any = null;	    // 開始年月日
    toYmd: any = null;		    // 終了年月日
    prjNo: any = null;         // プロジェクトNo.
    uids: any = [];	// 対象ユーザーIDのリスト
    tmptGt: any = null;		// 体温(以上)
    tmptUnt = "14";	    // 体温単位コード(14=摂氏)
    bprsUGt: any = null;	    // 血圧上（以上）
    bprsLLt: any = null;	    // 血圧下（以下）
    physcCndCd: any = null;	// 体調コード
    // 取得結果
    mpv008s: any;
}


/**
 * C040020JCコンテナ
 * 体調チェックとメール送信用
 */
export class C040020JC
{
    sysCd: any = null;          // システムコード
    tmpltCd: any = null;        // テンプレートコード
    tmptGt: any = null;		    // 異常体温閾値(この体温以上を異常とみなす)
    tmptUnt = "14";	    // 体温単位コード(14=摂氏)
    tmptDays: any = null;		// 基準体温異常連続日数
    physcCndCdGt: any = null;	// 異常体調コード閾値(この体調コード以上を異常とみなす）
    physcCndCdDays: any = null;	// 基準体調コード異常連続日数
}

/**
 * C040021JCコンテナ
 * 体調チェックとメール送信及びpush通知用
 */
export class C040021JC
{
    sysCd: any = null;          // システムコード
    tmpltCd: any = null;        // テンプレートコード
}

/**
 * C040040JCコンテナ
 * 体調異常アラート受信設定取得/更新用
 */
export class C040040JC
{
    inMpt045: any = null;          // 取得条件又は更新内容格納用
    outMpt045: any = null;         // 取得結果格納用
}

/**
 * C040050JCコンテナ
 * 身体測定値公開項目取得/更新用
 */
export class C040050JC
{
    inMpt046: any = null;          // 取得条件又は更新内容格納用
    outMpt046: any = null;         // 取得結果格納用
}

/**
 * C040060JCコンテナ
 * 体調記録登録/削除/取得と異常チェック 用
 */
export class C040060JC
{
	// sysCd: any = null;		// システムコード
	// tmpltCd: any = null;	// テンプレートコード
	inMpt216: any = null;	// 保存用
	recNo: any = null;		// 削除用レコード番号
	fromYmd: any = null;	// 取得開始年月日
	outMpt216s: any = null;	// 取得結果用
	aveBlPrU: any = null;	// 平均血圧（上）
	aveBlPrL: any = null;	// 平均血圧（下）
	maxBlPrU: any = null;	// 最高血圧（上）
	maxBlPrL: any = null;	// 最高血圧（下）
	msg2: any = null;		// 体調チェックメッセージ
}

/**
 *  C050010JCコンテナ
 * 店舗検索用
 */
export class C050010JC
{
	// 検索条件
    sysCd: any = null;      // システムコード
    tmpltCd: any = null;    // テンプレートコード
	shpNm: any = null;		// 店舗名
	shpPn: any = null;		// 店舗電話番号
	shpAddr: any = null;	// 店舗住所
	shpStn: any = null;		// 店舗最寄り駅
	shpIds: any = [];	    // 店舗IDのリスト
	includeMembers = false;	// メンバー登録している店舗の取得(true - 取得する、false –取得しない)
    // 検索結果(Mpt151のリスト)
    results: any = null;
    addShpId(obj: any)
    {
        this.shpIds.push(obj);
    }
}

/**
 *  C050020JCコンテナ
 * 店舗登録/更新用
 */
export class C050020JC
{
	mpt151 = new Mpt151();		// 店舗情報
	mpt047 = new Mpt047();     // プロジェクトお知らせ情報
}

/**
 *  C050030JCコンテナ
 * 店舗感染対策状況取得/登録用
 */
export class C050030JC
{
    // 検索条件
    shpId: any = null;		// 店舗ID
    chkAddPrsn: any = null; // 評価登録者端末ID
    // 登録、更新
    mpt152: any = null;		// 店舗チェック情報
    mpt153s: any = [];	// 店舗チェック結果
    shpChkCmnt: any = null;		// 感想
    // 検索結果
    result: any = null;
    addMpt153(obj: any)
    {
        this.mpt153s.push(obj);
    }
}

/**
 *  C050040JCコンテナ
 * 店舗感染対策状況サマリー取得用
 */
export class C050040JC
{
    // 検索条件
    shpId: any = null;		// 店舗ID
    // 検索結果
    result: any = null;
}

/**
 *  C050050JCコンテナ
 * 応援メッセージ登録用
 */
export class C050050JC
{
	// 登録用
	mpt156 = new Mpt156();	// 応援メッセージ
	// 登録結果用
	result: any = null;			// 登録済み応援メッセージ
}

/**
 *  C050060JCコンテナ
 * 店舗投稿写真登録/削除用
 */

export class C050060JC
{
    // 登録/削除用
    mpt152: any = null;     // 店舗チェック情報
    update154s: any = [];    // 更新用Mpt154のリスト
    // 削除後の店舗投稿写真
//    updated154s: any = null;
    addUpdateMpt154(obj: any)
    {
        this.update154s.push(obj);
    }
}

/**
 *  C050070JCコンテナ
 * 店舗一覧取得用
 */
export class C050070JC
{
	// 検索条件
    shpGrpId: any = null;	// 店舗グループID
    memUid: any = null;     // 検索対象メンバーのユーザーID
    sysCd: any = null;      // 検索用システムコード
    tmpltCd: any = null;    // 検索用テンプレートコード
    rllCds: any = [];       // 検索用役割コードの配列
    // 検索結果
    results: any = null;
    addRllCds(obj: any)
    {
        this.rllCds.push(obj);
    }
}

/**
 *  C050080JCコンテナ
 * イベントNo.から店舗検索用
 */
export class C050080JC
{
	// 検索条件
    sysCd: any = null;      // システムコード
    tmpltCd: any = null;    // テンプレートコード
	evntNo: any = null;		// イベントNo.
    // 検索結果
    results: any = null;
}

/**
 * C050090JCコンテナ
 * 店舗会員登録用
 */
export class C050090JC
{
    // 検索条件
    // inMpt014: any = null;   // 登録ユーザー情報
    mpt001: Mpt001 = new Mpt001();  // ユーザー基本情報
    invMail: any = false;    // 完了メール送信有無
    mailTmpl: any = null;   // 登録完了メール用テンプレートコード
    shpGrpId = 0;           // 店舗グループID
    shpId = 0;              // 店舗ID
}

/**
 * C050100JCコンテナ
 * 店舗グループ一覧 追加/取得/更新/削除用コンテナ
 */
export class C050100JC
{
	// 検索条件
    memUid: any = null;             // 検索対象メンバーのユーザーID
    sysCd: any = null;              // 検索用システムコード
    tmpltCd: any = null;            // 検索用テンプレートコード
    rllCds: any = [];      // 検索用役割コードの配列
    // 登録/更新用
    inMpt158: any = null;	// 登録店舗グループ
    // 結果用
    results: Mpt158[] = [];	// 店舗グループ一覧
    addRllCds(obj: any)
    {
        this.rllCds.push(obj);
    }
}

/**
 * C050110JCコンテナ
 * 会員ランク名称 登録/取得用コンテナ
 */
export class C050110JC
{
    // 検索用
    shpGrpId = 0;    // 店舗グループID
	// 登録用
    inMpt160s: Mpt160[] = [];	// 会員ランク名称のリスト
    // 結果用
    results: Mpt160[] = [];	// 会員ランク名称のリスト
    addMpt160(obj: any)
    {
        this.inMpt160s.push(obj);
    }
}

/**
 * C050120JCコンテナ
 * ポイント履歴登録/取得用コンテナ
 */
export class C050120JC
{
    // 検索用
    shpId = 0;       // 店舗ID
    memUid = 0;      // 検索対象会員のユーザーID
	// 登録用
    inMpt166: Mpt166 | null = null;   // 店舗売上履歴
    inMpt162s: Mpt162[] = [];	// 会員ポイント残高
    // 結果用
    result: any;	        // Mpt162, Rsc015が入る
    addMpt162(obj: any)
    {
        this.inMpt162s.push(obj);
    }
}

/**
 * C050130JCコンテナ
 * 店舗会員情報取得/更新用コンテナ
 */
export class C050130JC
{
    // 検索用
    shpGrpId = 0;    // 店舗グループID
    memUid = 0;      // 検索対象会員のユーザーID
	// 更新用
    inMpt159: any;	// 店舗会員情報
    // 結果用
    result: any;	        // Mpt159が入る
}

/**
 * C050140JCコンテナ
 * ポイント利用履歴取得用コンテナ
 */
export class C050140JC
{
    // 検索用
    memUid = 0;      // 検索対象会員のユーザーID
    shpGrpId = 0;    // 店舗グループID
    shpId = 0;       // 店舗ID
    pntTyp = "";     // ポイント種別
    ymPntExp = "";   // ポイント失効年月
    posSlpNo = "";   // 会計伝票番号
    addId = 0;       // 登録者ID
    fromYyyymm = ""; // 取得開始年月
    toYyyymm = "";   // 取得終了年月
    // 結果用
    result: any;	 // Mpv010のリストが入る
}

/**
 * C050150JCコンテナ
 * 店舗スタッフログイン処理用コンテナ
 */
export class C050150JC
{
    // ログイン用
	exstOrgUsrNm = "";	            // ユーザー名
	shpId = 0;			            // 店舗ID
	mpt003: Mpt003 = new Mpt003();	// 接続情
	// 結果用
	result = null;                  
}

/**
 * C050160JCコンテナ
 * 店舗スタッフ仮パスワード発行処理用コンテナ
 */
export class C050160JC
{
    // ログイン情報
    shpId = 0;			// 店舗ID
	usrNm = "";	        // ユーザー名
    mailTmpl = "";      // メールテンプレートファイル名
            
}

/**
 * C050170JCコンテナ
 * 情報検索用コンテナ
 */
export class C050170JC
{
    // 検索用
    shpId = 0;			// 店舗ID
	monthsPast = 0;	    // 過去月数
    fromYyyymm = "";    // 取得開始年月
    toYyyymm = "";      // 取得終了年月
    erngTyps:string[] = [];      // 売上種別
    // 結果用
    rsc017s = null;     // 月別のポイント、売上、来客数
    rsc018 = null;      // ポイント、売上、来客数サマリー
}

/*****************************************************************
 Jsonコンテナで利用するクラス定義
 *****************************************************************/

/**
* ユーザー基本情報
*/
export class Mpt001
{
    uid: any = null;        // ユーザーID
    cntryCd: any = null;    // 国コード
    dob: any = null;        // 生年月日
    dstnctCd: any = null;   // 居住地域
    eml: any = null;        // Eメール
    gndr: any = null;       // 性別
    nckNm: any = null;      // ニックネーム
    psnlCmpnyKbn: any = null;   // 個人_法人区分
    rmrks: any = null;      // 注記
    sttsCd: any = null;     // 状況コード
    uTyp: any = null;       // ユーザータイプ
    mpt002: any = new Mpt002();     // Mpt002
}

 /**
  * パスワード
  */
export class Mpt002
{
    uid: any = null;
    pwd: any = null;
}

/**
 * 接続情報
 */
export class Mpt003
{
	id = new Mpt003PK(); // Mpt010PK（必須）
	cnctMtd = "";      // 接続方式（必須）
	cnctSttsCd = "";  // 接続ステータスコード
	ipaddr = "";       // IPアドレス
	sysCd = "";        // システムコード（必須）
	tmpltCd = "";      // テンプレートコード（必須）
	trmnlTyp = "";     // 接続端末（必須）
}
export class Mpt003PK
{
    uid = 0;    // ユーザーID
}

/**
 * ユーザー補足情報１
 */
/*
export class Mpt006
{
	uid: any = null;    // ユーザーID
	capUnt = MemottaResourceBundle.getString("UNIT.CODE.lt");  // 単位（容積）
	dstUnt = MemottaResourceBundle.getString("UNIT.CODE.km");  // 単位（距離）
	hgtCm: any = null;  // 身長(cm)
	hgtFt: any = null;  // 身長(Ft)
	hgtIn: any = null;  // 身長(inch)
	hgtUnt = MemottaResourceBundle.getString("UNIT.CODE.cm");  // 単位（身長）
	pht: any = null;    // 画像
	tmptUnt = MemottaResourceBundle.getString("UNIT.CODE.ct"); // 単位（温度）
	updTs: any = null;  // 更新日時
	wghtUnt = MemottaResourceBundle.getString("UNIT.CODE.kg"); // 単位（重さ）
}
*/

/**
 * オーナープロジェクト情報
 */
export class Mpt007
{
    prjNo: any = null;      // プロジェクトNo
    uid: any = null;        // 所有者のユーザーID
    addId: any = null;      // 登録者のユーザーID
    prjDesc: any = null;    // プロジェクト説明
    prjTtl: any = null;     // プロジェクトタイトル
    prjPubKbn: any = null;  // プロジェクト公開区分
    sysCd: any = null;      // システムコード
    tmpltCd: any = null;    // テンプレートコード
    prjLogo: any = null;    // プロジェクトロゴ
    prjPht: any = null;     // プロジェクト写真
    prjUrl: any = null;     // プロジェクトURL
}
/*
export class keepMpt007(mpt007Org: any)
{
    mpt007Keep.prjNo = mpt007Org.prjNo;
    mpt007Keep.addId = mpt007Org.addId;
    mpt007Keep.prjDesc = mpt007Org.prjDesc;
    mpt007Keep.prjTtl = mpt007Org.prjTtl;
    mpt007Keep.prjPubKbn = mpt007Org.prjPubKbn;
    mpt007Keep.sysCd = mpt007Org.sysCd;
    mpt007Keep.tmpltCd = mpt007Org.tmpltCd;
    mpt007Keep.prjLogo = mpt007Org.prjLogo;
    mpt007Keep.prjPht = mpt007Org.prjPht;
    mpt007Keep.prjUrl = mpt007Org.prjUrl;
}
*/

/**
 * 役割_メンバー
 */
export class Mpt010
{
    id: any = null;     // Mpt010PK（必須）
    addId: any = null;  // 登録者（必須）
    mpt014: any = null; // Mpt014（必須）
}
export class Mpt010PK
{
     prjNo: any = null;
     rllCd: any = null;
     uid: any = null;
}
/**
 * 引数で渡されたMpt010リスト内に役割コードが存在するかチェックする
 *
 * @param Mpt010s Mpt010のリスト
 * @param rllCds 検索する役割コードのリスト
 * @return true - 存在する、 false - 存在しない
 */
export function existsRllCdsInMpt010s(mpt010s: any, rllCds: any)
{
    if ( mpt010s == null  ) return false;
    for ( let i = 0; i < mpt010s.length; i++ )
    {
       if( rllCds.includes(mpt010s[i].id.rllCd) ) return true;
    }
    return false;
}

/**
 * プロジェクト内メンバー
 */
export class Mpt014
{
    id: any = null;             // Mpt014PK
    addId: any = null;          // 登録者
    exstOrgUid = "9999";   // 組織内ユーザーID(初期値は9999)
    exstOrgUsrNm: any = null;   // 組織内ユーザー名
    mbrInvtSttsCd: any = null;  // メンバー招待ステータスコード
    orgNo: any = null;          // 組織No
    mpt001: any = new Mpt001();         // Mpt001
    mpt010s: any = []; // Mpt010のリスト
    addMpt010(obj: any)
    {
        this.mpt010s.push(obj);
    }
}
export class Mpt014PK
{
    prjNo: any = null;  // プロジェクトNo
    uid: any = null;    // ユーザーID
}

/**
 * イベント_アクション
 */
export class Mpt016
{
    actNo: any = null;
    addId: any = null;
    evntNo: any = null;
    mpt017s: any = [];
    mpt019s: any = [];
    mpt020s: any = [];
    mpt021s: any = [];
    mpt022s: any = [];
    mpt023s: any = [];
    mpt024s: any = [];
    addMpt017(obj: any)
    {
        this.mpt017s.push(obj);
    }
    addMpt019(obj: any)
    {
        this.mpt019s.push(obj);
    }
    addMpt020(obj: any)
    {
        this.mpt020s.push(obj);
    }
    addMpt021(obj: any)
    {
        this.mpt021s.push(obj);
    }
    addMpt022(obj: any)
    {
        this.mpt022s.push(obj);
    }
    addMpt023(obj: any)
    {
        this.mpt023s.push(obj);
    }
    addMpt024(obj: any)
    {
        this.mpt024s.push(obj);
    }
}

/**
 * アクション付属情報共通PK
 */
export class ActionInfoPK
{
    actNo = 0;             // アクションNo.
    actRecType = "";   // アクションレコードタイプ
    constructor(actNo: number, actRecType: string)
    {
        this.actNo = actNo;             // アクションNo.
        this.actRecType = actRecType;   // アクションレコードタイプ
    }
}

/**
 * アクション_文字列
 */
export class Mpt020
{
    id: any;        // Mpt020PK（必須）
    cntryCd = "JP";   // 国コード
    langCd = "ja";    // 言語コード
    strVal = "";    // 文字列
}
/**
 * Mpt020オブジェクトの引数でアクションレコードタイプの文字列を返す
 * @param mpt016 アクション情報
 * @param actRecType アクションレコードタイプ
 * @return 文字列
 */
export function getMpt020Val(mpt016: any, actRecType: string)
{
    if ( mpt016 != null && mpt016.mpt020s != null )
    {
        for ( let i = 0; i < mpt016.mpt020s.length; i++ )
        {
            if ( mpt016.mpt020s[i].id.actRecType == actRecType )
            {
                return(mpt016.mpt020s[i].strVal);
            }
        }
    }
    return(null);
}
/**
 * Mpt020オブジェクトに値をセットして返す
 * @param actNo アクションNo.
 * @param actRecType アクションレコードタイプ
 * @param str 文字列
 * @return Mpt020オブジェクト
 */
export function createMpt020Val(actNo: number, actRecType: string, str: string)
{
    const id = new ActionInfoPK(actNo, actRecType);
    const mpt020 = new Mpt020();
    mpt020.id = id;
    if ( str != null && str != "" ) {mpt020.strVal = str;}
    return(mpt020);
}

/**
 * .アクション_ナンバー
 */
export class Mpt021
{
    id: any = null;        // Mpt021PK（必須）
    intVal = 0;    // 整数値
    decVal = 0;    // 小数値
    untCd = "";     // 単位コード
}
/**
 * Mpt021オブジェクトの引数でアクションレコードタイプの整数を返す
 * @param mpt016 アクション情報
 * @param actRecType アクションレコードタイプ
 * @return 整数
 */
export function getMpt021IntVal(mpt016: any, actRecType: string)
{
    if ( mpt016 != null && mpt016.mpt021s != null )
    {
        for ( let i = 0; i < mpt016.mpt021s.length; i++ )
        {
            if ( mpt016.mpt021s[i].id.actRecType == actRecType )
            {
                return(mpt016.mpt021s[i].intVal);
            }
        }
    }
    return(null);
}
/**
 * Mpt021オブジェクトの引数でアクションレコードタイプの小数を返す
 * @param mpt016 アクション情報
 * @param actRecType アクションレコードタイプ
 * @return 小数
 */
export function getMpt021DecVal(mpt016: any, actRecType: string)
{
    if ( mpt016 != null && mpt016.mpt021s != null )
    {
        for ( let i = 0; i < mpt016.mpt021s.length; i++ )
        {
            if ( mpt016.mpt021s[i].id.actRecType == actRecType )
            {
                return(mpt016.mpt021s[i].decVal);
            }
        }
    }
    return(null);
}
/**
 * Mpt021オブジェクトの引数でアクションレコードタイプの単位コードを返す
 * @param mpt016 アクション情報
 * @param actRecType アクションレコードタイプ
 * @return 単位コード
 */
export function getMpt021UnitCd(mpt016: any, actRecType: string)
{
    if ( mpt016 != null && mpt016.mpt021s != null )
    {
        for ( let i = 0; i < mpt016.mpt021s.length; i++ )
        {
            if ( mpt016.mpt021s[i].id.actRecType == actRecType )
            {
                return(mpt016.mpt021s[i].untCd);
            }
        }
    }
    return(null);
}
/**
 * Mpt021オブジェクトに値をセットして返す
 * @param actNo アクションNo.
 * @param actRecType アクションレコードタイプ
 * @param intVal 整数値
 * @param decVal 小数値
 * @param untCd 単位コード
 * @return Mpt021オブジェクト
 */
export function createMpt021Val(actNo: number, actRecType: string, intVal: number, decVal: number, untCd: string)
{
    const id = new ActionInfoPK(actNo, actRecType);
    const mpt021 = new Mpt021();
    mpt021.id = id;
    if ( intVal != null ) { mpt021.intVal = intVal; }
    if ( decVal != null ) { mpt021.decVal = decVal; }
    if ( untCd != null && untCd != "" ) { mpt021.untCd = untCd; }
    return(mpt021);
}

/**
 * .アクション_フラグ
 */
export class Mpt022
{
    id: any = null;        // Mpt022PK（必須）
    flgVal = "";    // フラグ
}
/**
 * Mpt022オブジェクトの引数でアクションレコードタイプの文字列を返す
 * @param mpt016 アクション情報
 * @param actRecType アクションレコードタイプ
 * @return 文字列
 */
export function getMpt022Val(mpt016: any, actRecType: string)
{
    if ( mpt016 != null && mpt016.mpt022s != null )
    {
        for ( let i = 0; i < mpt016.mpt022s.length; i++ )
        {
            if ( mpt016.mpt022s[i].id.actRecType == actRecType )
            {
                return(mpt016.mpt022s[i].flgVal);
            }
        }
    }
    return(null);
}
/**
 * Mpt022オブジェクトに値をセットして返す
 * @param actNo アクションNo.
 * @param actRecType アクションレコードタイプ
 * @param ch 文字
 * @return Mpt022オブジェクト
 */
export function createMpt022Val(actNo: number, actRecType: string, ch: string)
{
    const id = new ActionInfoPK(actNo, actRecType);
    const mpt022 = new Mpt022();
    mpt022.id = id;
    if ( ch != null && ch != "" ) {mpt022.flgVal = ch.charAt(0);}
    return(mpt022);
}


/**
 * イベント
 */
export class Mpt025
{
    prjNo: any = null;      // プロジェクトNo.
    evntNo: any = null;     // イベントNo.
    evntTtl: any = null;    // イベントタイトル
    evntKbn: any = null;    // イベント区分
    evntPbStrtYmd: any = null;    // 公開開始年月日
    evntPbStrtHhmmss: any = null; // 公開開始時刻
    evntPbEndYmd: any = null;     // 公開終了年月日
    evntPbEndHhmmss: any = null;  // 公開終了時刻
    evntStrtYmd: any = null;      // イベント開始年月日
    evntStrtHhmmss: any = null;   // イベント開始時刻
    evntEndYmd: any = null;       // イベント終了年月日
    evntEndHhmmss: any = null;    // イベント終了時刻
    evntCnclTs: any = null;       // イベント中止決定日時
    rptNo: any = null;      // 繰り返しNo.
    addId: any = null;      // 登録者ID
    mpt033: any = null;     // 繰り返し情報
    mpt026s: any = []; // Mpt026のリスト
    mpt028s: any = []; // Mpt028のリスト
    mpt029s: any = []; // Mpt029のリスト
    mpt030s: any = []; // Mpt030のリスト
    mpt031s: any = []; // Mpt031のリスト
    mpt032s: any = []; // Mpt032のリスト
    mpt034s: any = []; // Mpt034のリスト
    addMpt026(obj: any){this.mpt026s.push(obj);}
    addMpt028(obj: any){this.mpt028s.push(obj);}
    addMpt029(obj: any){this.mpt029s.push(obj);}
    addMpt030(obj: any){this.mpt030s.push(obj);}
    addMpt031(obj: any){this.mpt031s.push(obj);}
    addMpt032(obj: any){this.mpt032s.push(obj);}
    addMpt034(obj: any){this.mpt034s.push(obj);}
}

/**
 * イベント付属情報共通PK
 */
export class EventInfoPK
{
    evntNo = 0;           // イベントNo.
    evntRecType = ""; // イベントレコードタイプ
    constructor(evntNo: number, evntRecType: string)
    {    
        this.evntNo = evntNo;           // イベントNo.
        this.evntRecType = evntRecType; // イベントレコードタイプ
    }
}

/**
 * イベント_年月日時分
 */
export class Mpt026
{
    id: any = null;             // Mpt026PK（必須）
    hhmmssVal = "";      // 時刻
    tzVal = "JST";         // タイムゾーン
    yyyymmddVal = "";    // 年月日
}
/**
 * Mpt026オブジェクトの引数でイベントレコードタイプのYYYYMMDD文字列を返す
 * @param mpt025 イベント情報
 * @param evntRecType イベントレコードタイプ
 * @return 文字列
 */
export function getMpt026GetYyyymmddVal(mpt025: any, evntRecType: string)
{
    if ( mpt025 != null && mpt025.mpt026s != null )
    {
        for ( let i = 0; i < mpt025.mpt026s.length; i++ )
        {
            if ( mpt025.mpt026s[i].id.evntRecType == evntRecType )
            {
                return(mpt025.mpt026s[i].yyyymmddVal);
            }
        }
    }
    return(null);
}
/**
 * Mpt026オブジェクトの引数でイベントレコードタイプのHHMMSS文字列を返す
 * @param mpt025 イベント情報
 * @param evntRecType イベントレコードタイプ
 * @return 文字列
 */
export function getMpt026GetHhmmssVal(mpt025: any, evntRecType: string)
{
    if ( mpt025 != null && mpt025.mpt026s != null )
    {
        for ( let i = 0; i < mpt025.mpt026s.length; i++ )
        {
            if ( mpt025.mpt026s[i].id.evntRecType == evntRecType )
            {
                return(mpt025.mpt026s[i].hhmmssVal);
            }
        }
    }
    return(null);
}
/**
 * Mpt026オブジェクトに値をセットして返す
 * @param evntNo イベントNo.
 * @param evntRecType イベントレコードタイプ
 * @param yyyymmddVal 年月日
 * @param hhmmssVal 時刻
 * @return Mpt026オブジェクト
 */
export function createMpt026Val(evntNo: number, evntRecType: string, yyyymmddVal: string, hhmmssVal: string)
{
    const id = new EventInfoPK(evntNo, evntRecType);
    const mpt026 = new Mpt026();
    mpt026.id = id;
    if ( yyyymmddVal != null && yyyymmddVal != "" ) {mpt026.yyyymmddVal = yyyymmddVal;}
    if ( hhmmssVal != null && hhmmssVal != "" ) {mpt026.hhmmssVal = hhmmssVal;}
    return(mpt026);
}

/**
 * イベント_文字列
 */
export class Mpt029
{
    id: any = null;        // Mpt029PK（必須）
    cntryCd = "JP";   // 国コード
    langCd = "ja";    // 言語コード
    strVal = "";    // 文字列
}
/**
 * Mpt029オブジェクトの引数でイベントレコードタイプの文字列を返す
 * @param mpt025 イベント情報
 * @param evntRecType イベントレコードタイプ
 * @return 文字列
 */
export function getMpt029Val(mpt025: any, evntRecType: string)
{
    if ( mpt025 != null && mpt025.mpt029s != null )
    {
        for ( let i = 0; i < mpt025.mpt029s.length; i++ )
        {
            if ( mpt025.mpt029s[i].id.evntRecType == evntRecType )
            {
                return(mpt025.mpt029s[i].strVal);
            }
        }
    }
    return(null);
}
/**
 * Mpt029オブジェクトに値をセットして返す
 * @param evntNo イベントNo.
 * @param evntRecType イベントレコードタイプ
 * @param str 文字列
 * @return Mpt029オブジェクト
 */
export function createMpt029Val(evntNo: number, evntRecType: string, str: string)
{
    const id = new EventInfoPK(evntNo, evntRecType);
    const mpt029 = new Mpt029();
    mpt029.id = id;
    if ( str != null && str != "" ) {mpt029.strVal = str;}
    return(mpt029);
}

/**
 * .イベント_フラグ
 */
export class Mpt031
{
    id: any = null;        // Mpt031PK（必須）
    flgVal = "";    // フラグ
}
/**
 * Mpt031オブジェクトの引数でイベントレコードタイプの文字列を返す
 * @param mpt025 イベント情報
 * @param evntRecType イベントレコードタイプ
 * @return 文字列
 */
export function getMpt031Val(mpt025: any, evntRecType: string)
{
    if ( mpt025 != null && mpt025.mpt031s != null )
    {
        for ( let i = 0; i < mpt025.mpt031s.length; i++ )
        {
            if ( mpt025.mpt031s[i].id.evntRecType == evntRecType )
            {
                return(mpt025.mpt031s[i].flgVal);
            }
        }
    }
    return(null);
}
/**
 * Mpt031オブジェクトに値をセットして返す
 * @param evntNo イベントNo.
 * @param evntRecType イベントレコードタイプ
 * @param ch 文字
 * @return Mpt031オブジェクト
 */
export function createMpt031Val(evntNo: number, evntRecType: string, ch: string)
{
    const id = new EventInfoPK(evntNo, evntRecType);
    const mpt031 = new Mpt031();
    mpt031.id = id;
    if ( ch != null && ch != "" ) {mpt031.flgVal = ch.charAt(0);}
    return(mpt031);
}

/**
 * イベント繰り返し情報
 */
export class Mpt033
{
	rptNo: any = null;
	endYmd: any = null;
	rptCyclKbn: any = null;
	rptD01 = false;
	rptD02 = false;
	rptD03 = false;
	rptD04 = false;
	rptD05 = false;
	rptD06 = false;
	rptD07 = false;
	rptD08 = false;
	rptD09 = false;
	rptD10 = false;
	rptD11 = false;
	rptD12 = false;
	rptD13 = false;
	rptD14 = false;
	rptD15 = false;
	rptD16 = false;
	rptD17 = false;
	rptD18 = false;
	rptD19 = false;
	rptD20 = false;
	rptD21 = false;
	rptD22 = false;
	rptD23 = false;
	rptD24 = false;
	rptD25 = false;
	rptD26 = false;
	rptD27 = false;
	rptD28 = false;
	rptD29 = false;
	rptD30 = false;
	rptD31 = false;
	rptDysIntvl: any = null;
	rptEom = false;
	rptFri = false;
	rptMnsIntvl: any = null;
	rptMon = false;
	rptSat = false;
	rptSun = false;
	rptThu = false;
	rptTue = false;
	rptWed = false;
	rptWksIntvl: any = null;
	strtYmd: any = null;
}

/**
 * イベント通知
 */
export class Mpt034
{
    id: any = null;           // Mpt034PK（必須）
    evntRmnDys = 0;   // イベント開始残(日)
    evntRmnHrs = 0;   // イベント開始残(時)
    evntRmnMins = 0;  // イベント開始残(分)
}
export class Mpt034PK
{
    evntNo = 0;         // イベントNo.
    evntNtfyTs: any = null;     // 通知時刻
}
// export let mpt034_evntNtfyTs = 0;      // イベント通知予定時刻
/**
 * Mpt034オブジェクトのイベント開始残日数を返す
 * @param mpt025 イベント情報
 * @return イベント開始残日数
 */
 /*
export class getMpt034GetEvntRmnDays(mpt025)
{
    if ( mpt025.mpt034s != null )
    {
        for ( let i = 0; i < mpt025.mpt034s.length; i++ )
        {
            if ( mpt025.mpt034s[i].evntRmnDys != null && mpt025.mpt034s[i].evntNtfdTs == null )
            {
                return(mpt025.mpt034s[i].evntRmnDys);
            }
        }
    }
    return(null);
}
*/
/**
 * Mpt034オブジェクトのイベント開始残時間を返す
 * @param mpt025 イベント情報
 * @return イベント開始残時間
 */
 /*
export class getMpt034GetEvntRmnHr(mpt025)
{
    if ( mpt025.mpt034s != null )
    {
        for ( let i = 0; i < mpt025.mpt034s.length; i++ )
        {
            if ( mpt025.mpt034s[i].evntRmnHrs != null  && mpt025.mpt034s[i].evntNtfdTs == null )
            {
                return(mpt025.mpt034s[i].evntRmnHrs);
            }
        }
    }
    return(null);
}
*/
/**
 * Mpt034オブジェクトに値をセットして返す
 * @param evntNo イベントNo.
 * @param evntRmnDys イベント開始残(日数)
 * @param evntRmnHrs イベント開始残(時間)
 * @param evntRmnMins イベント開始残(分)
 * @return Mpt034オブジェクト
 */
export function createMpt034Val(evntNo: number, evntRmnDys: number, evntRmnHrs: number, evntRmnMins: number, evntNtfyTs: any)
{
    const mpt034PK = new Mpt034PK();
    mpt034PK.evntNo = evntNo;
    const mpt034 = new Mpt034();
    mpt034.id = mpt034PK;
    // 日数指定
    if ( evntRmnDys != null && evntRmnDys != -1 )
    {
        mpt034.evntRmnDys = evntRmnDys;
     }
    // 時間指定
    if ( evntRmnHrs != null && evntRmnHrs != -1 )
    {
        mpt034.evntRmnHrs = evntRmnHrs;
    }
    // 分指定
    if ( evntRmnMins != null && evntRmnMins != -1 )
    {
        mpt034.evntRmnMins = evntRmnMins;
    }
    // イベント通知予定時刻をセットする
    // mpt034.id.evntNtfyTs = mpt034_evntNtfyTs;
    mpt034.id.evntNtfyTs = evntNtfyTs;
    return(mpt034);
}

/**
 * 有料オプション確認状況
 */
export class Mpt039
{
    id: any = null;         // Mpt039PK(必須）
    optCd: any = null;      // オプションコード(必須）
    optSttsCd: any = null;  // オプションステータスコード
}
export class Mpt039PK
{
    uid: any = null;        // ユーザーID(必須）
    sysCd: any = null;      // システムコード(必須）
    tmpltCd: any = null;    // テンプレートコード(必須）
    optStrCd: any = null;   // オプション購入ストアコード(必須）
    strOptCd: any = null;   // ストアーオプションコード(必須）
}

/**
 * ユーザー保有端末ID
 */
export class Mpt040
{
    id: any = null;         // Mpt040PK(必須）
    trmnlTkn: any = null;   // 端末トークン(必須）
    trmnlTyp: any = null;   // 端末タイプ(必須）
}
export class Mpt040PK
{
    uid: any = null;        // ユーザーID(必須）
    sysCd: any = null;      // システムコード(必須）
    tmpltCd: any = null;    // テンプレートコード(必須）
    trmnlId: any = null;    // 端末ID（必須）

}

/**
 * ユーザー設定情報
 */
export class Mpt041
{
    id: any = null;              // Mpt041PK(必須）
    strtAplyYmd: any = null;     // 適用開始年月日
    endAplyYmd: any = null;      // 適用終了年月日
    usrCnfgItmVal1: any = null;  // ユーザー設定項目１(必須）
    usrCnfgItmVal2: any = null;  // ユーザー設定項目２
    usrCnfgItmVal3: any = null;  // ユーザー設定項目３
    usrCnfgItmVal4: any = null;  // ユーザー設定項目４
    usrCnfgItmVal5: any = null;  // ユーザー設定項目５
}
export class Mpt041PK
{
    uid: any = null;                    // ユーザーID(必須）
    sysCd: any = null;              // システムコード(必須）
    tmpltCd: any = null;            // テンプレートコード(必須）
    usrCnfgItmCd: any = null;   // ユーザー設定項目コード（必須）
}


/*
 * 体調異常アラート受信設定
 */
export class Mpt045
{
    prjNo: any = null;                          // プロジェクトNo.
	bprsLMx: any = null;                      // 収縮期血圧閾値
	bprsLMxDys: any = null;                // 収縮期血圧異常連続日数
	bprsUMx: any = null;                     // 拡張期血圧閾値
	bprsUMxDys: any = null;               // 拡張期血圧異常連続日数
	physcCndCdMx: any = null;           // 体調コード閾値
	physcCndCdMxDys: any = null;     // 体調コード常連続日数
    swRcvAlrt = false;               // アラート受信スイッチ
    tmptMx: any = null;                     // 体温閾値
    untCd: any = null;                      // 単位コード
    tmptMxDys: any = null;              // 体温異常連続日数
}

/*
 * 身体測定公開項目
 */
export class Mpt046
{
	swBprs = false;     // 血圧公開スイッチ
	swHrtBt = false;    // 脈拍公開スイッチ
    swPhyscCnd = false; // 体調公開スイッチ
    swSymptm = false;   // 症状公開スイッチ
    swTmpt = false;     // 体温公開スイッチ
}
export class Mpt046PK
{
    prjNo: any = null;       // プロジェクトNo.
	uid: any = null;         // ユーザーID
}

/**
 * プロジェクトお知らせ情報
 */
export class Mpt047
{
	prjNo = 0;          // プロジェクトNo.
	prjInfCntnt: any = null;    // お知らせ
	prjInfEndYmd: any = null;   // お知らせ公開開始年月日（未使用）
	prjInfStrtYmd: any = null;  // お知らせ公開終了年月日（未使用）
}

/*
 * お知らせマスター
 */
export class Mpt059
{
	ntfyNo: any = null;      // お知らせNo.
	endAplyDt: any = null;   // 適用終了日付
	mxCntGet: any = null;    // 取得回数上限
	ntfyCntnt: any = null;   // お知らせ内容
	ntfyTtl: any = null;     // お知らせタイトル
	strtAplyDt: any = null;  // 適用開始日付
	sysCd: any = null;       // システムコード
	tmpltCd: any = null;     // テンプレートコード
	uid: any = null;         // お知らせ対象ユーザーID
}

/**
 * 店舗情報
 */
export class Mpt151
{
    shpId: any = null;          // 店舗ID
    // sysCd = sysCd;         // システムコード
    // tmpltCd = tmpltCd;     // テンプレートコード
    sysCd: any = null;         // システムコード
    tmpltCd: any = null;     // テンプレートコード
    prjNo = 0;             // プロジェクトコード
    chkAddPrsn: any = null;     // 評価登録者端末ID
    chkUpdPrsn: any = null;     // 評価更新者端末ID
    shpAcs: any = null;         // 店舗_アクセス
    shpAddr: any = null;        // 店舗_住所
    shpAlttd: any = null;       // 店舗_高度
    shpLg: any = null;          // 店舗_ロゴ
    shpLngtd: any = null;       // 店舗_経度
    shpLttd: any = null;        // 店舗_緯度
    shpNm: any = null;          // 店舗名
    shpPhnNo: any = null;       // 店舗_電話番号
    shpPht: any = null;         // 店舗_写真
    shpPstCd: any = null;       // 店舗_郵便番号
    shpUrl: any = null;         // 店舗_URL
    cntrctSttsCd: any = null;   // 契約状況コード
    shpGrpId: any = null;       // 店舗グループID
    mpt152s: any = []; // 店舗チェック情報のリスト
    mpt155s: any = []; // 店舗付属情報のリスト
    addMpt152(obj: any)
    {
        this.mpt152s.push(obj);
    }
    addMpt155(obj: any)
    {
        this.mpt155s.push(obj);
    }
}

/**
 * 店舗チェック情報
 */
export class Mpt152
{
    id = new Mpt152PK();   // Mpt152PK
    shpChkCmnt: any = null;     // 店舗チェック時コメント
}
export class Mpt152PK
{
	shpId: any = null;      // 店舗ID
	chkAddPrsn: any = null; // 評価登録者端末ID
}

/**
 * 店舗チェック結果
 */
export class Mpt153
{
    id = new Mpt153PK();   // Mpt153PK
	chkVal: any = null;         // チェック結果
}
export class Mpt153PK
{
	shpId: any = null;      // 店舗ID
	chkAddPrsn: any = null; // 評価登録者端末ID
	chkItmNo = 0;      // チェック項目番号

}

/**
 * 店舗投稿写真
 */
export class Mpt154
{
	shpId: any = null;          // 店舗ID
	chkAddPrsn: any = null;     // 評価登録者端末ID
	shpPstPht: any = null;      // 写真(base64)
	shpPstPhtCmnt: any = null;  // コメント
}

/**
 * 店舗付属情報
 */
export class Mpt155
{
    id: any = new Mpt155PK();   // Mpt155PK
	shpVal = "";         // 店舗付属情報_値
}
export class Mpt155PK
{
	shpId: any = null;              // 店舗ID
	shpInfRecTyp: any = null;       // 店舗付属情報レコードタイプ
	shpInfRecTypSeq: any = null;    // 店舗付属情報レコードタイプ内番号
}
/**
 * Mpt155オブジェクトを作成する
 * @param shpId 店舗ID
 * @param shpInfRecTyp 店舗付属情報レコードタイプ
 * @param shpInfRecTypSeq 店舗付属情報レコードタイプ内番号
 * @param shpVal 店舗付属情報_値
 * @return Mpt155オブジェクト
 */
export function createMpt155Val(shpId: number, shpInfRecTyp: string, shpInfRecTypSeq: number, shpVal: string)
{
    const mpt155 = new Mpt155();
    mpt155.id.shpId = shpId;
    mpt155.id.shpInfRecTyp = shpInfRecTyp;
    mpt155.id.shpInfRecTypSeq = shpInfRecTypSeq;
    mpt155.shpVal = shpVal;
    return(mpt155);
}
/**
 * Mpt155のリストから引数で指定された店舗付属情報レコードタイプを持つオブジェクトを削除した
 * Mpt155のリスつを作成して返す
 * @param mpt155s Mpt155のリスト
 * @param shpInfRecTyp 削除対象の店舗付属情報レコードタイプ
 * @return 削除済みのMpt155のリスト
 */
export function deleteMpt155Val(mpt155s: any, shpInfRecTyp: string)
{
    if ( mpt155s == null ) { return null; }
    const newMpt155s: any = [];
    for ( let i = 0; i < mpt155s.length; i++ )
    {
        if ( mpt155s[i].id.shpInfRecTyp != shpInfRecTyp )
        {
            newMpt155s.push(mpt155s[i]);
        }
    }
    return newMpt155s;
}
/**
 * Mpt151オブジェクトに関連しているMpt155オブジェクトから引数で渡された
 * 店舗付属情報レコードタイプに設定された店舗付属情報_値を文字列のリストでを返す
 * @param mpt151 店舗情報
 * @param shpInfRecTyp 店舗付属情報レコードタイプ
 * @return 店舗付属情報_値のリスト
 */
export function getMpt155Vals(mpt151: any, shpInfRecTyp: string)
{
    const shpVals: any = [];
    if ( mpt151 != null && mpt151.mpt155s != null )
    {
        for ( let i = 0; i < mpt151.mpt155s.length; i++ )
        {
            if ( mpt151.mpt155s[i].id.shpInfRecTyp == shpInfRecTyp )
            {
                shpVals.push(mpt151.mpt155s[i].shpVal);
            }
        }
    }
    return(shpVals);
}


/**
 * 応援メッセージ
 */
export class Mpt156
{
    id = new Mpt156PK();   // Mpt156PK
	gdlckMsg: any = null;       // 応援メッセージ
}
export class Mpt156PK
{
	shpId: any = null;          // 店舗ID
	chkAddPrsn: any = null;     // 評価登録者端末ID
}


/**
 * 店舗グループ情報
 */
export class Mpt158
{
	shpGrpId: any = null;   // 店舗ID
    sysCd: any = null;      // システムコード
    tmpltCd: any = null;    // テンプレートコード
	shpGrpNm = "";          // 店舗グループ名
    nwMbrRnkCd = "";        // 入会時会員ランクコード
    jnPntVal = 0;           // 入会ポイント数
    // オブジェクトをコピーする
    copy(org: Mpt158)
    {
        this.shpGrpId = org.shpGrpId;
        this.sysCd = org.sysCd;
        this.tmpltCd = org.tmpltCd;
        this.shpGrpNm = org.shpGrpNm;
        this.nwMbrRnkCd = org.nwMbrRnkCd;
        this.jnPntVal = org.jnPntVal;
    }
}

/**
 * 会員ランク名称
 */
export class Mpt159
{
    id = new Mpt159PK();    // Mpt160PK
	mbrRnkCd = "";          // 会員ランクコード
    note = "";              // ノート
}
export class Mpt159PK
{
    uid = 0;        // 会員ランクコード
	shpGrpId = 0;   // 店舗グループID
}

/**
 * 会員ランク名称
 */
export class Mpt160
{
    id = new Mpt160PK();    // Mpt160PK
	mbrRnkNm = "";          // 会員ランク名称
    pntEfctMnts = 0;        // ポイント有効月数
    mpt161s: any = [];      // Mpt161のリスト
    addMpt161(obj: any)
    {
        this.mpt161s.push(obj);
    }
}
export class Mpt160PK
{
	shpGrpId = 0;     // 店舗グループID
	mbrRnkCd = "";    // 会員ランクコード
}

/**
 * 会員ランク別ポイントマスター
 */
export class Mpt161
{
    id = new Mpt161PK();    // Mpt161PK
    pntVal = 0;             // ポイント数
    pntRto = 0;             // ポイント付与率
}
export class Mpt161PK
{
	shpGrpId: any = null;     // 店舗グループID
	mbrRnkCd = "";            // 会員ランクコード
    pntTyp = "";              // ポイント種別
}

/**
 * 会員ポイント履歴
 */
export class Mpt162
{
    pntTrnNo = 0;   // ポイントトランザクションNo.
    uid = 0;        // ユーザーID
    shpGrpId = 0;   // 店舗グループID    
    shpId = 0;      // 店舗ID
    pntTyp = "";     // ポイント種別
    pntVal = 0;     // ポイント数
    ymPntExp = "";  // ポイント失効年月
    pntAdjstMemo = "";    // ポイント調整メモ

    // 後で削除する
    posSlpNo = "";  // 会計伝票番号
    pyAmnt= 0;      // 支払額
    
    addTs: any;     // 登録日時
}

export class Mpt166
{
    shpErngTrnNo: any = null;   // 店舗売上トランザクションNo
	uid = 0;        // ユーザーID  
	shpGrpId = 0;   // 店舗グループID
	shpId = 0;      // 店舗ID
	erngTyp = "";   // 売上種別
	erngYmd = "";   // 売上年月日
	posSlpNo = "";  // 会計伝票番号
	erngAmnt = 0;   // 売上金額
	numPpl = 0;     // 人数
	acctCd = "";    // 勘定科目コード
    pntTrnNo = 0;   // ポイントトランザクションNo.
}

/**
 * メモ_リマインダー
 */
export class Mpt202
{
	id = new Mpt202PK();    // Mpt202PK
	memoNtfdTs: any = null;      // メモ通知完了時刻
	memoRmnDys: any = null;     // メモ開始残(日数)
	memoRmnHrs: any = null;     // メモ開始残(時間)
	memoRmnMins: any = null;    // メモ開始残(分)
}
export class Mpt202PK
{
	memoNo: any = null;         // メモ番号
	memoNtfyTs: any = null;     // メモ通知予定時刻
}
// export let mpt202_memoNtfyTs = 0;    // メモ通知予定時刻

/*
 * 体調記録
 */
export class Mpt216
{
	recNo: any = null;       // レコード番号
	bprsL: any = null;       // 血圧（下）
    bprsU: any = null;       // 血圧（上）
    hrtBt: any = null;       // 脈拍
    physcCndCd: any = null;  // 体調コード
    recTs: any = null;       // 記録時刻
    symptmCd: any = null;    // 症状コード
    tmpt: any = null;        // 体温
    uid: any = null;         // ユーザーID
    unt: any = null;         // 体温単位コード
}

/**
 * メンバープロジェクト参加状況ビュー
 */
export class Mpv003
{
	uid: any = null;        // メンバーのユーザーID
	mbrInvtSttsCd: any = null; // メンバー招待ステータスコード
	prjNo: any = null;      // プロジェクトNo.
	prjTtl: any = null;     // プロジェクトタイトル
	prjDesc: any = null;    // プロジェクト説明
    prjLogo: any = null;    // プロジェクトロゴ
    prjPht: any = null;     // プロジェクト写真
	rllCd: any = null;      // 役割コード
	prjPubKbn: any = null;  // プロジェクト公開区分
	// prjLogo: any = null;    // プロジェクトロゴ
	// prjPht: any = null;     // プロジェクト写真
	prjUrl: any = null;     // プロジェクトURL
}

/**
 * 体調一覧ビュー
 */
export class Mpv008
{
	ymd = "";   // 年月日
	uid = 0;   // ユーザーID
	prjNo = 0; // プロジェクトNo.
	nckNm = ""; // ニックネーム
	eml = "";   // Eメールアドレス
	tmpt = 0;      // 体温
	tmptUnt = "";   // 体温単位コード
	bprsU = 0; // 血圧(上)
	bprsL = 0; // 血圧(下)
	physcCndCd = "";    // 体調コード
}

/**
 * 店舗会員ポイント履歴ビュー
 */
export class Mpv010
{
    /* ポイントトランザクションNo */
	pntTrnNo = 0;	
	/* ユーザーID */
	uid = 0;
    /* 会員名 */
    nckNm = "";
	/* 店舗グループID */
	shpGrpId = 0;	
	/* 店舗ID */
	shpId = 0;	
	/* 店舗名 */
	shpNm = "";	
	/* ポイント種別 */
	pntTyp = "";	
	/* ポイント種別名称 */
	pntTypNm = "";		
	/* ポイント数 */
	pntVal = 0;
	/* ポイント失効年月 */
	ymPntExp = "";
	/* ポイント調整メモ */
	pntAdjstMemo = "";
	/* 会計伝票番号 */
	posSlpNo = "";	
	/* 売上額 */
	erngAmnt = 0;
	/* 登録日時 */
	addTs = null;	
	/* 登録者ID */
	addId = 0;	
	/* 登録者名 */
	addNm = "";
}